module.exports = __webpack_public_path__ + "static/img/03.4fa589f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/03.png
// module id = pelp
// module chunks = 0